export default {
  name: 'gmk-yuri',
  override: {
    KC_ENT: 'accent',
    KC_ESC: 'accent'
  }
};
